import { createFileRoute } from '@tanstack/react-router'
import { BellRing } from 'lucide-react'
import { NotificationPreferencesScreen } from '@/screens/me/SCR-124-notification-preferences'

export const Route = createFileRoute('/_app/me/notification-preferences')({
  staticData: { screen: { id: 'SCR-124', title: 'Notification preferences', group: 'Me', order: 6, description: 'Choose what ESM tells you about, and how.', icon: BellRing } },
  component: NotificationPreferencesScreen,
})
